var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, trigger, state, style, transition, animate } from "@angular/core";
import { ImageService } from "../services/image.service";
export var ViewerComponent = (function () {
    function ViewerComponent(ImageService) {
        var _this = this;
        this.ImageService = ImageService;
        this.images = [{}];
        this.currentIdx = 0;
        this.leftArrowVisible = true;
        this.rightArrowVisible = true;
        this.qualitySelectorShown = false;
        this.qualitySelected = 'auto';
        this.categorySelected = 'preview_xxs';
        ImageService.imagesUpdated$.subscribe(function (images) {
            _this.images = images;
        });
        ImageService.imageSelectedIndexUpdated$.subscribe(function (newIndex) {
            _this.currentIdx = newIndex;
            _this.images.forEach(function (image) { return image['active'] = false; });
            _this.images[_this.currentIdx]['active'] = true;
            _this.transform = 0;
            _this.updateQuality();
        });
        ImageService.showImageViewerChanged$.subscribe(function (showViewer) {
            _this.showViewer = showViewer;
        });
        this.Math = Math;
    }
    Object.defineProperty(ViewerComponent.prototype, "leftArrowActive", {
        get: function () {
            return this.currentIdx > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewerComponent.prototype, "rightArrowActive", {
        get: function () {
            return this.currentIdx < this.images.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    ViewerComponent.prototype.pan = function (swipe) {
        this.transform = swipe.deltaX;
    };
    ViewerComponent.prototype.onResize = function () {
        this.images.forEach(function (image) {
            image['viewerImageLoaded'] = false;
            image['active'] = false;
        });
        this.updateImage();
    };
    ViewerComponent.prototype.showQualitySelector = function () {
        this.qualitySelectorShown = !this.qualitySelectorShown;
    };
    ViewerComponent.prototype.qualityChanged = function (newQuality) {
        this.qualitySelected = newQuality;
        this.updateImage();
    };
    ViewerComponent.prototype.imageLoaded = function (image) {
        image['viewerImageLoaded'] = true;
    };
    /**
     * direction (-1: left, 1: right)
     * swipe (user swiped)
     */
    ViewerComponent.prototype.navigate = function (direction, swipe) {
        if ((direction === 1 && this.currentIdx < this.images.length - 1) ||
            (direction === -1 && this.currentIdx > 0)) {
            if (direction == -1) {
                this.images[this.currentIdx]['transition'] = 'leaveToRight';
                this.images[this.currentIdx - 1]['transition'] = 'enterFromLeft';
            }
            else {
                this.images[this.currentIdx]['transition'] = 'leaveToLeft';
                this.images[this.currentIdx + 1]['transition'] = 'enterFromRight';
            }
            this.currentIdx += direction;
            if (swipe) {
                this.hideNavigationArrows();
            }
            else {
                this.showNavigationArrows();
            }
            this.updateImage();
        }
    };
    ViewerComponent.prototype.hideNavigationArrows = function () {
        this.leftArrowVisible = false;
        this.rightArrowVisible = false;
    };
    ViewerComponent.prototype.showNavigationArrows = function () {
        this.leftArrowVisible = true;
        this.rightArrowVisible = true;
    };
    ViewerComponent.prototype.closeViewer = function () {
        this.images.forEach(function (image) { return image['transition'] = undefined; });
        this.images.forEach(function (image) { return image['active'] = false; });
        this.ImageService.showImageViewer(false);
    };
    ViewerComponent.prototype.updateImage = function () {
        var _this = this;
        // wait for animation to end
        setTimeout(function () {
            _this.updateQuality();
            _this.images[_this.currentIdx]['active'] = true;
            _this.images.forEach(function (image) {
                if (image != _this.images[_this.currentIdx]) {
                    image['active'] = false;
                    _this.transform = 0;
                }
            });
        }, 500);
    };
    ViewerComponent.prototype.updateQuality = function () {
        var screenWidth = window.innerWidth;
        var screenHeight = window.innerHeight;
        switch (this.qualitySelected) {
            case 'auto': {
                this.categorySelected = 'preview_xxs';
                if (screenWidth > this.images[this.currentIdx]['preview_xxs'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_xxs'].height) {
                    this.categorySelected = 'preview_xs';
                }
                if (screenWidth > this.images[this.currentIdx]['preview_xs'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_xs'].height) {
                    this.categorySelected = 'preview_s';
                }
                if (screenWidth > this.images[this.currentIdx]['preview_s'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_s'].height) {
                    this.categorySelected = 'preview_m';
                }
                if (screenWidth > this.images[this.currentIdx]['preview_m'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_m'].height) {
                    this.categorySelected = 'preview_l';
                }
                if (screenWidth > this.images[this.currentIdx]['preview_l'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_l'].height) {
                    this.categorySelected = 'preview_xl';
                }
                if (screenWidth > this.images[this.currentIdx]['preview_xl'].width &&
                    screenHeight > this.images[this.currentIdx]['preview_xl'].height) {
                    this.categorySelected = 'raw';
                }
                break;
            }
            case 'low': {
                this.categorySelected = 'preview_xxs';
                break;
            }
            case 'mid': {
                this.categorySelected = 'preview_m';
                break;
            }
            case 'high': {
                this.categorySelected = 'raw';
                break;
            }
        }
    };
    ViewerComponent.prototype.onKeydown = function (event) {
        var prevent = [37, 39, 27, 36, 35]
            .find(function (no) { return no === event.keyCode; });
        if (prevent) {
            event.preventDefault();
        }
        switch (prevent) {
            case 37:
                // navigate left
                this.navigate(-1, false);
                break;
            case 39:
                // navigate right
                this.navigate(1, false);
                break;
            case 27:
                // esc
                this.closeViewer();
                break;
            case 36:
                // pos 1
                this.images[this.currentIdx]['transition'] = 'leaveToRight';
                this.currentIdx = 0;
                this.images[this.currentIdx]['transition'] = 'enterFromLeft';
                this.updateImage();
                break;
            case 35:
                // end
                this.images[this.currentIdx]['transition'] = 'leaveToLeft';
                this.currentIdx = this.images.length - 1;
                this.images[this.currentIdx]['transition'] = 'enterFromRight';
                this.updateImage();
                break;
        }
    };
    ViewerComponent = __decorate([
        Component({
            selector: 'viewer',
            template: '<div class="outerContainer" (window:resize)="onResize($event)" *ngIf="showViewer" [@showViewerTransition]="showViewer"><md-button-toggle-group *ngIf="qualitySelectorShown" (change)="qualityChanged($event.value)" name="quality"><md-button-toggle value="auto" checked="true">Auto</md-button-toggle><md-button-toggle value="low">Low</md-button-toggle><md-button-toggle value="mid">Mid</md-button-toggle><md-button-toggle value="high">High</md-button-toggle></md-button-toggle-group><img [ngClass]="{\'activeArrow\': leftArrowActive}" class="arrow left" src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0cHgiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczpza2V0Y2g9Imh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaC9ucyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjx0aXRsZS8+PGRlc2MvPiAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgaWQ9Im1pdSIgc3Ryb2tlPSIjNTU1IiBzdHJva2Utd2lkdGg9IjAuMiI+ICAgICA8ZyBpZD0iQXJ0Ym9hcmQtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5NS4wMDAwMDAsIC0xOTEuMDAwMDAwKSI+PGcgaWQ9InNsaWNlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTUuMDAwMDAwLCAxMTkuMDAwMDAwKSIvPjxwYXRoICAgICAgIGQ9Ik0zOTYsMjAyLjUgQzM5NiwxOTYuMTQ4NzI1IDQwMS4xNDg3MjUsMTkxIDQwNy41LDE5MSBDNDEzLjg1MTI3NSwxOTEgNDE5LDE5Ni4xNDg3MjUgNDE5LDIwMi41IEM0MTksMjA4Ljg1MTI3NSA0MTMuODUxMjc1LDIxNCA0MDcuNSwyMTQgQzQwMS4xNDg3MjUsMjE0IDM5NiwyMDguODUxMjc1IDM5NiwyMDIuNSBaIE00MDguNjU2ODU0LDE5Ni44NDMxNDYgTDQxMC4wNzEwNjgsMTk4LjI1NzM1OSBMNDA1LjgyODQyNywyMDIuNSBMNDEwLjA3MTA2OCwyMDYuNzQyNjQxIEw0MDguNjU2ODU0LDIwOC4xNTY4NTQgTDQwMywyMDIuNSBMNDA4LjY1Njg1NCwxOTYuODQzMTQ2IFoiICAgICAgIGZpbGw9IiNhYWEiICAgICAgIGlkPSJjaXJjbGUtYmFjay1hcnJvdy1nbHlwaCIvPjwvZz4gICA8L2c+IDwvc3ZnPg==" [hidden]="!leftArrowVisible" (click)="navigate(-1)"> <img [ngClass]="{\'activeArrow\': rightArrowActive}" class="arrow right" src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0cHgiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczpza2V0Y2g9Imh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaC9ucyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjx0aXRsZS8+PGRlc2MvPjxkZWZzLz4gICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGlkPSJtaXUiIHN0cm9rZT0iIzU1NSIgc3Ryb2tlLXdpZHRoPSIwLjIiPiAgICAgPGcgaWQ9IkFydGJvYXJkLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NjcuMDAwMDAwLCAtMTkxLjAwMDAwMCkiPjxnIGlkPSJzbGljZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE1LjAwMDAwMCwgMTE5LjAwMDAwMCkiLz48cGF0aCAgICAgICBkPSJNNDY4LDIwMi41IEM0NjgsMTk2LjE0ODcyNSA0NzMuMTQ4NzI1LDE5MSA0NzkuNSwxOTEgQzQ4NS44NTEyNzUsMTkxIDQ5MSwxOTYuMTQ4NzI1IDQ5MSwyMDIuNSBDNDkxLDIwOC44NTEyNzUgNDg1Ljg1MTI3NSwyMTQgNDc5LjUsMjE0IEM0NzMuMTQ4NzI1LDIxNCA0NjgsMjA4Ljg1MTI3NSA0NjgsMjAyLjUgWiBNNDgwLjY1Njg1NCwxOTYuODQzMTQ2IEw0ODIuMDcxMDY4LDE5OC4yNTczNTkgTDQ3Ny44Mjg0MjcsMjAyLjUgTDQ4Mi4wNzEwNjgsMjA2Ljc0MjY0MSBMNDgwLjY1Njg1NCwyMDguMTU2ODU0IEw0NzUsMjAyLjUgTDQ4MC42NTY4NTQsMTk2Ljg0MzE0NiBaIiAgICAgICBmaWxsPSIjYWFhIiAgICAgICBpZD0iY2lyY2xlLW5leHQtYXJyb3ctZGlzY2xvc3VyZS1nbHlwaCIgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDc5LjUwMDAwMCwgMjAyLjUwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtNDc5LjUwMDAwMCwgLTIwMi41MDAwMDApICIvPjwvZz4gICA8L2c+IDwvc3ZnPg==" [hidden]="!rightArrowVisible" (click)="navigate(1)"><div class="buttonContainer"><img class="action close" src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwcHgiIGlkPSJMYXllcl8xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgdmVyc2lvbj0iMS4xIiBmaWxsPSIjYWFhIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgPHBhdGggICAgc3Ryb2tlLXdpZHRoPSIzMCIgc3Ryb2tlPSIjNDQ0IiAgICBkPSJNNDM3LjUsMzg2LjZMMzA2LjksMjU2bDEzMC42LTEzMC42YzE0LjEtMTQuMSwxNC4xLTM2LjgsMC01MC45Yy0xNC4xLTE0LjEtMzYuOC0xNC4xLTUwLjksMEwyNTYsMjA1LjFMMTI1LjQsNzQuNSAgYy0xNC4xLTE0LjEtMzYuOC0xNC4xLTUwLjksMGMtMTQuMSwxNC4xLTE0LjEsMzYuOCwwLDUwLjlMMjA1LjEsMjU2TDc0LjUsMzg2LjZjLTE0LjEsMTQuMS0xNC4xLDM2LjgsMCw1MC45ICBjMTQuMSwxNC4xLDM2LjgsMTQuMSw1MC45LDBMMjU2LDMwNi45bDEzMC42LDEzMC42YzE0LjEsMTQuMSwzNi44LDE0LjEsNTAuOSwwQzQ1MS41LDQyMy40LDQ1MS41LDQwMC42LDQzNy41LDM4Ni42eiIvPjwvc3ZnPg==" (click)="closeViewer()"></div><button md-fab disableRipple class="menuButton" (click)="showQualitySelector()"><md-icon>settings</md-icon></button><div class="imageContainer" (click)="showNavigationArrows()" (swipeleft)="navigate(1, $event)" (swiperight)="navigate(-1, $event)" (pan)="pan($event)"><div *ngFor="let img of images; let j = index" class="image" [class.active]="img[\'active\']" [@imageTransition]="img[\'transition\']" [style.background-image]="img[\'viewerImageLoaded\'] ? \'url(\'+img[categorySelected][\'path\']+\')\' : Math.abs(currentIdx-j) <=1 ? \'url(\'+img[\'preview_xxs\'][\'path\']+\')\' : \'\'" [style.left]="transform+\'px\'"></div><img *ngFor="let img of images; let j = index" class="preloading-image" (load)="imageLoaded(img)" src="{{ Math.abs(currentIdx-j) <=1 ? img[categorySelected][\'path\'] : \'\'}}"></div></div>',
            styles: ['.imageContainer .image.active,.outerContainer{left:0;right:0;top:0;bottom:0;height:100%;width:100%}.outerContainer{position:fixed;background-color:rgba(0,0,0,.95);font-family:sans-serif}.imageContainer{position:absolute;float:none;top:0;bottom:0;left:0;right:0}.imageContainer .image,.imageContainer .preloading-image{visibility:hidden}.imageContainer .image.active{position:absolute;visibility:visible;background-repeat:no-repeat;background-size:contain;background-position:center;margin:auto;opacity:1}.arrow{opacity:0}.arrow:hover{cursor:pointer}.outerContainer:hover .arrow.activeArrow{height:calc(20px + 1.5vw);position:absolute;top:calc(50% - (20px + 1.5vw)/ 2);bottom:50%;z-index:1;opacity:1;transition:all ease-out .5s}.arrow.left{left:2vw}.arrow.right{right:2vw}.arrow:not(.activeArrow):hover{opacity:0;cursor:pointer;transition:all ease-out .5s}.buttonContainer,.menuButton{position:absolute;right:20px;text-align:center;opacity:1}.buttonContainer{top:20px;height:20px;z-index:200;transition:all ease-out .5s}.buttonContainer .action{height:100%;cursor:pointer;vertical-align:top}.buttonContainer .action:focus{outline:0}.buttonContainer .action:hover{background-color:#222;transition:all ease-out .3s}.buttonContainer .action.close{width:26px;height:26px}md-button-toggle-group{display:table;top:70px;margin:0 auto;background-color:#fff;z-index:500}md-button-toggle.checked{background-color:#a0a0a0}.menuButton{bottom:20px;z-index:200;transition:all ease-out .5s}[md-fab],[md-mini-fab]{background-color:#aaa}@font-face{font-family:\'Material Icons\';font-style:normal;font-weight:400;src:local(\'Material Icons\'),local(\'MaterialIcons-Regular\'),url(https://fonts.gstatic.com/s/materialicons/v19/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2) format(\'woff2\')}.material-icons{font-family:\'Material Icons\';font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-feature-settings:\'liga\';-webkit-font-smoothing:antialiased}'],
            host: {
                '(document:keydown)': 'onKeydown($event)',
            },
            animations: [
                trigger('imageTransition', [
                    state('enterFromRight', style({
                        opacity: 1,
                        transform: 'translate(0px, 0px)'
                    })),
                    state('enterFromLeft', style({
                        opacity: 1,
                        transform: 'translate(0px, 0px)'
                    })),
                    state('leaveToLeft', style({
                        opacity: 0,
                        transform: 'translate(-100px, 0px)'
                    })),
                    state('leaveToRight', style({
                        opacity: 0,
                        transform: 'translate(100px, 0px)'
                    })),
                    transition('* => enterFromRight', [
                        style({
                            opacity: 0,
                            transform: 'translate(30px, 0px)'
                        }),
                        animate('250ms 500ms ease-in')
                    ]),
                    transition('* => enterFromLeft', [
                        style({
                            opacity: 0,
                            transform: 'translate(-30px, 0px)'
                        }),
                        animate('250ms 500ms ease-in')
                    ]),
                    transition('* => leaveToLeft', [
                        style({
                            opacity: 1
                        }),
                        animate('250ms ease-out')]),
                    transition('* => leaveToRight', [
                        style({
                            opacity: 1
                        }),
                        animate('250ms ease-out')])
                ]),
                trigger('showViewerTransition', [
                    state('true', style({
                        opacity: 1
                    })),
                    state('void', style({
                        opacity: 0
                    })),
                    transition('void => *', [
                        style({
                            opacity: 0
                        }),
                        animate('1000ms ease-in')]),
                    transition('* => void', [
                        style({
                            opacity: 1
                        }),
                        animate('500ms ease-out')])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [ImageService])
    ], ViewerComponent);
    return ViewerComponent;
}());
//# sourceMappingURL=c:/dev/ng2imggallery/src/app/viewer/viewer.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-image-gallery/app/viewer/viewer.component.js
// module id = 682
// module chunks = 3